import saveAs from 'file-saver'
import domtoimage from 'dom-to-image'
var sanitize = require('sanitize-filename')
var slugify = require('slugify')
    ; (function ($) {
        'use strict'

        // Return if not proper template
        if (!$('body').hasClass('page-template-workforce-data-center')) return

        // Handle URI vars
        var tabURI = getURIParameterByName('tab'),
            stateVariableURI = getURIParameterByName('var'),
            stateURI = getURIParameterByName('states'),
            stateFilterList = [],
            nationalVariableURI = getURIParameterByName('natvar')

        if (stateURI) {
            stateURI = stateURI.split(',')
            $.each(stateURI, function (index, value) {
                var stateObject = us.lookup(value)
                stateFilterList.push(stateObject.name)
            })
        }

        // Add is-active class to set tab
        if (tabURI) {
            $('section.constructive-tab[data-tab-label="' + tabURI + '"]').addClass(
                'is-active'
            )
        }

        var stateSection = $('section.constructive-tab.state'),
            nationalSection = $('section.constructive-tab.national')

        var stateDatasets = [],
            stateDataset = '',
            stateDataTable,
            stateTableData = [],
            stateTable = $('.workforce-data-center-state'),
            stateTableTitle = $('.workforce-data-center-state-title'),
            stateTableNewNode =
                '<table class="workforce-data-center-state" class="display" cellspacing="0" width="100%"><thead><tr></tr></thead><tfoot><tr></tr></tfoot></table>',
            stateFilterVariable = '',
            stateMapPaths = $(
                'div.workforce-data-center-filter-state-map svg path'
            ),
            stateWashingtonDC = $(
                'div.workforce-data-center-filter-state-map span.washington-dc'
            ),
            stateRhodeIsland = $(
                'div.workforce-data-center-filter-state-map span.rhode-island'
            ),
            stateColumnHover = $('div.workforce-data-center-hover'),
            stateHoverData = [],
            stateHoverCurrent = '',
            stateHoverChartType = '',
            stateHoverChartTitle = '',
            stateHoverChartColumns = [],
            stateHoverChartGroupBy = '',
            stateHoverChartValueFormat = '',
            nationalDatasets = [],
            nationalDataset = '',
            nationalTable = $('.workforce-data-center-national'),
            nationalTableNewNode =
                '<table class="workforce-data-center-national" class="display" cellspacing="0" width="100%"><thead><tr></tr></thead><tfoot><tr></tr></tfoot></table>',
            nationalTableTitle = $('.workforce-data-center-national-title'),
            nationalFilterVariable = '',
            nationalDataTable

        var defaultStateDataset,
            defaultStateDatasetLabel,
            defaultNationalDataset,
            defaultNationalDatasetLabel

        $.ajax({
            cache: false,
            url: '/wp-json/grab-acf/454',
            type: 'GET',
            dataType: 'json',
            success: function (result, s, x) {
                defaultStateDatasetLabel = result.wdc_default_state_dataset
                defaultNationalDatasetLabel = result.wdc_default_national_dataset
                stateDatasets = result.wdc_state_datasets
                nationalDatasets = result.wdc_national_datasets
                initializeWorkforceDataCenter()
            },
            error: function (x, s, e) {
                console.log(x, s, e)
            }
        })

        var initializeWorkforceDataCenter = function () {
            if (stateVariableURI) defaultStateDatasetLabel = stateVariableURI
            var stateDatasetMap = $.map(stateDatasets, function (object) {
                if (object.label == defaultStateDatasetLabel) return object
            })

            defaultStateDataset = stateDatasetMap[0].dataset
            stateHoverChartTitle = stateDatasetMap[0].chart_title
                ? stateDatasetMap[0].chart_title
                : stateDatasetMap[0].label
            stateHoverChartType = stateDatasetMap[0].chart_type
            stateHoverChartGroupBy = stateDatasetMap[0].group_by_column
            stateHoverChartValueFormat = stateDatasetMap[0].chart_value_format
            updateStateHoverColumns(stateDatasetMap[0])
            updateMethodology(stateSection, stateDatasetMap[0].methodology)

            if (nationalVariableURI)
                defaultNationalDatasetLabel = nationalVariableURI
            var nationalDatasetMap = $.map(nationalDatasets, function (object) {
                if (object.label == defaultNationalDatasetLabel) return object
            })

            defaultNationalDataset = nationalDatasetMap[0].dataset

            parseStateDataset(defaultStateDataset)
            stateFilterVariable = encodeSpacesToPlus(defaultStateDatasetLabel)
            stateFilterByVariable.val(stateFilterVariable).trigger('change')

            parseNationalDataset(defaultNationalDataset)
            nationalFilterVariable = encodeSpacesToPlus(defaultNationalDatasetLabel)
            nationalFilterByVariable.val(nationalFilterVariable).trigger('change')
            updateMethodology(nationalSection, nationalDatasetMap[0].methodology)
        }

        var parseStateDataset = function (dataset, destroy) {
            if (destroy) {
                stateDataTable.destroy(true)
                $('section.constructive-tab.state div.table-container').append(
                    stateTableNewNode
                )
                stateTable = $('.workforce-data-center-state')
            }

            Papa.parse(dataset, {
                download: true,
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    stateTableData = results.data

                    var keys = results.meta.fields,
                        count = [],
                        formattedHeaderData = []

                    // Build header row
                    $.each(keys, function (index) {
                        var newObject = {}
                        count.push(index)
                        newObject.data = this
                        formattedHeaderData.push(newObject)
                    })

                    count.shift() // Remove first for orderable
                    buildTableHeader(keys, stateTable)
                    stateTableTitle.text(stateHoverChartTitle);
                    stateDataTable = stateTable.DataTable({
                        data: stateTableData,
                        columns: formattedHeaderData,
                        rowsGroup: [0],
                        columnDefs: [
                            { orderable: false, targets: count },
                            { orderable: true, targets: [0] }
                        ],
                        order: [[0, 'asc']],
                        paging: false
                    })

                    syncStateMap()
                    triggerStateFilter()
                    appendSeeMore()
                }
            })
        }

        var parseNationalDataset = function (dataset, destroy) {
            if (destroy) {
                nationalDataTable.destroy(true)
                $('section.constructive-tab.national div.table-container').append(
                    nationalTableNewNode
                )
                nationalTable = $('.workforce-data-center-national')
            }

            Papa.parse(dataset, {
                download: true,
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    var tableData = results.data,
                        keys = results.meta.fields,
                        count = [],
                        formattedHeaderData = []

                    // Build header row
                    $.each(keys, function (index) {
                        var newObject = {}
                        count.push(index)
                        newObject.data = this
                        formattedHeaderData.push(newObject)
                    })

                    count.shift() // Remove first for orderable
                    count.shift() // Remove area!
                    buildTableHeader(keys, nationalTable)
                    
                    // stateTableTitle.text(stateHoverChartTitle);
                    nationalDataTable = nationalTable.DataTable({
                        data: tableData,
                        columns: formattedHeaderData,
                        columnDefs: [
                            { visible: false, targets: [0] },
                            { orderable: false, targets: count },
                            { orderable: true, targets: [1] }
                        ],
                        paging: false
                    })
                    setNationalTableTitle();
                }
            })
        }

        var setNationalTableTitle = () => {
            var dataset_row = nationalDatasets.filter((row) => {
                return row.label === nationalFilterByVariable.val().replace(/\+/g, ' ');
            });
            $('.workforce-data-center-national-title').text(dataset_row.length && dataset_row[0].chart_title.length ? dataset_row[0].chart_title : '');
        }

        // NOTE: This runs three times on init and twice afterward with rowsGroup extension
        // TODO: See if this can be reduced to only once
        // We're listening to the parent since stateTable object gets destroyed
        stateTable.parent().on('draw.dt', function () {
            var table = $(this)
            classifyRowGroups(table)
            updateStateColumnCells(table)
            if (stateHoverCurrent !== '') stateColumnCellsUpdateChart()
        })

        var buildTableHeader = function (headerList, target) {
            var tableHeaders = ''
            $.each(headerList, function (index, value) {
                tableHeaders += '<th>' + value + '</th>'
            })
            target
                .find('thead tr')
                .empty()
                .append(tableHeaders)
        }

        var stateFilterByVariable = $(
            'div.workforce-data-center-filter-state-controls select.variable'
        ).select2({
            placeholder: 'Data type',
            minimumResultsForSearch: Infinity,
            allowClear: false
        })

        stateFilterByVariable.on('select2:select', function (event) {
            var value = stateFilterByVariable.val()
            updateURIParameterByName('var', value)
            var matchedStateObject = $.grep(stateDatasets, function (e) {
                return e.label == decodePlusToSpace(value)
            })
            stateHoverChartTitle = matchedStateObject[0].chart_title
                ? matchedStateObject[0].chart_title
                : matchedStateObject[0].label
            stateHoverChartType = matchedStateObject[0].chart_type
            stateHoverChartGroupBy = matchedStateObject[0].group_by_column
            stateHoverChartValueFormat = matchedStateObject[0].chart_value_format

            updateStateHoverColumns(matchedStateObject[0])

            updateMethodology(stateSection, matchedStateObject[0].methodology)

            parseStateDataset(matchedStateObject[0].dataset, true)
        })

        stateFilterByVariable.on('select2:unselect', function (event) {
            updateURIParameterByName('var', null)
        })

        var nationalFilterByVariable = $(
            'div.workforce-data-center-filter-national-controls select.variable'
        ).select2({
            placeholder: 'Data type',
            minimumResultsForSearch: Infinity,
            allowClear: false
        })

        nationalFilterByVariable.on('select2:select', function (event) {
            var value = nationalFilterByVariable.val()
            updateURIParameterByName('natvar', value)
            var matchedNationalObject = $.grep(nationalDatasets, function (e) {
                return e.label == decodePlusToSpace(value)
            })
            parseNationalDataset(matchedNationalObject[0].dataset, true)
            updateMethodology(nationalSection, matchedNationalObject[0].methodology)
        })

        nationalFilterByVariable.on('select2:unselect', function (event) {
            updateURIParameterByName('natvar', null)
        })

        var stateList = us.STATES,
            formattedStateList = []

        $.each(stateList, function (index) {
            var newKeyValue = {}
            newKeyValue.id = this.name
            newKeyValue.text = this.name
            formattedStateList.push(newKeyValue)
        })

        var filterByState = $(
            'div.workforce-data-center-filter-state-controls select.state'
        )
            .select2({
                minimumResultsForSearch: Infinity,
                placeholder: 'State',
                allowClear: true,
                data: formattedStateList
            })
            .val(stateFilterList)
            .trigger('change')

        filterByState.on('select2:select', function (event) {
            stateTableShowAll()
            filterByStateChanged(this)
        })

        filterByState.on('select2:unselect', function (event) {
            filterByStateChanged(this)
        })

        var filterByStateChanged = function (object) {
            var theSelect = $(object),
                stateValues = theSelect.val()
            // If first value is blank string, remove it
            // Bug in clear for multiselect in select2
            if (stateValues[0] === '') stateValues.shift()
            stateFilterList = stateValues
            updateStateList()
        }

        stateMapPaths.click(function (event) {
            var clickedState = $(this),
                fipsID = String(clickedState.data('fips')), // STRING!
                stateObject = us.lookup(fipsID),
                stateName = stateObject['name']
            if (clickedState.hasClass('is-active')) {
                stateFilterList.splice($.inArray(stateName, stateFilterList), 1)
            } else {
                stateFilterList.push(stateName)
            }
            stateTableShowAll()
            updateStateList()
        })

        stateWashingtonDC.click(function (event) {
            var fipsID = '11',
                stateObject = us.lookup(fipsID),
                stateName = stateObject['name'],
                washingtonDCpath = $(
                    'div.workforce-data-center-filter-state-map svg path[data-fips="' +
                    fipsID +
                    '"]'
                )
            if (washingtonDCpath.hasClass('is-active')) {
                stateFilterList.splice($.inArray(stateName, stateFilterList), 1)
            } else {
                stateFilterList.push(stateName)
            }
            stateTableShowAll()
            updateStateList()
        })

        stateRhodeIsland.click(function (event) {
            var fipsID = '44',
                stateObject = us.lookup(fipsID),
                stateName = stateObject['name'],
                rhodeIslandPath = $(
                    'div.workforce-data-center-filter-state-map svg path[data-fips="' +
                    fipsID +
                    '"]'
                )
            if (rhodeIslandPath.hasClass('is-active')) {
                stateFilterList.splice($.inArray(stateName, stateFilterList), 1)
            } else {
                stateFilterList.push(stateName)
            }
            stateTableShowAll()
            updateStateList()
        })

        var syncStateMap = function () {
            stateMapPaths.removeClass('is-active')
            stateWashingtonDC.removeClass('is-active')
            stateRhodeIsland.removeClass('is-active')
            $.each(stateFilterList, function (index) {
                var stateID = us.lookup(this),
                    matchedStatePath = $(
                        'div.workforce-data-center-filter-state-map svg path[data-fips="' +
                        stateID.fips +
                        '"]'
                    )
                matchedStatePath.addClass('is-active')
                if (stateID.fips === '11') {
                    stateWashingtonDC.addClass('is-active')
                } else if (stateID.fips === '44') {
                    stateRhodeIsland.addClass('is-active')
                }
            })
        }

        var updateStateList = function () {
            filterByState.val(stateFilterList).trigger('change')
            syncStateMap()
            triggerStateFilter()

            var stateFilterURI = []
            $.each(stateFilterList, function (index, value) {
                var stateObject = us.lookup(value)
                stateFilterURI[index] = stateObject.fips
            })
            updateURIParameterByName('states', stateFilterURI)
        }

        var updateStateHoverColumns = function (stateObject) {
            // console.log('STATE COLUMNS',stateObject.selected_columns);
            var newColumns = stateObject.selected_columns,
                newColumnValue = []
            stateHoverChartColumns = []
            $.each(newColumns, function (key, value) {
                //   console.log(value.label);
                newColumnValue.push(value.label)
            })

            stateHoverChartColumns = newColumnValue
        }

        var triggerStateFilter = function () {
            // Prepare state name list as regex
            var stateFilterRegex = []
            $.each(stateFilterList, function (index, value) {
                stateFilterRegex[index] = '^' + value // Exact string match
            })
            stateFilterRegex = stateFilterRegex.join('|')
            stateTable
                .DataTable()
                .column(0)
                .order('asc')
                .search(stateFilterRegex, true, false)
                .draw()
        }

        // Create bottom border for row groups
        var classifyRowGroups = function (table) {
            var rowGroupVisibleStates = table.find('tr td:first-child:visible'), // Assuming state first
                allTR = table.find('tr'),
                previousRowGroupTR = rowGroupVisibleStates.parent('tr').prev()

            allTR.removeClass('last-row')
            previousRowGroupTR.addClass('last-row')
        }

        var updateStateColumnCells = function (table) {
            var latestStateColumns = table.find('tr td:first-child:visible')

            latestStateColumns.off('mousemove')
            latestStateColumns.on('mousemove', stateColumnCellsHover)
            latestStateColumns.off('mouseleave')

            // testing
            latestStateColumns.mouseleave(function (e) {
                stateColumnHover.removeClass('is-active')
            })

            latestStateColumns.off('mouseenter')
            latestStateColumns.on('mouseenter', function () {
                stateColumnHover.addClass('is-active')
            })
        }

        var stateColumnCellsHover = function (event) {
            if (!$('section.state div.dataTables_wrapper').hasClass('show-all'))
                return

            var target = $(event.target),
                stateName = target.text(),
                td = $(event.target).closest('td.sorting_1')

            if (stateHoverCurrent !== stateName && target[0] === td[0]) {
                stateHoverCurrent = stateName
                stateColumnCellsUpdateChart()
            }

            stateColumnHover.css({
                transform:
                    'translate(' +
                    (event.pageX + 40) +
                    'px, ' +
                    (event.pageY - 47) +
                    'px)'
            })
        }

        var stateColumnCellsUpdateChart = function () {
            // Clear state hover data
            stateHoverData = []

            $.each(stateTableData, function (key, value) {
                var tempData = {}
                if (value.Area === stateHoverCurrent) {
                    $.each(value, function (key, value) {
                        if (key === stateHoverChartGroupBy) {
                            tempData[key] = value
                        } else {
                            tempData[key] = deformatUnits(value)
                        }
                    })
                    stateHoverData.push(tempData)
                }
            })

            if (stateHoverChartType === 'pairedbarchart') {
                renderPairedBarChart()
            } else if (stateHoverChartType === 'stackedbarchart') {
                renderStackedBarChart()
            }
        }

        var renderPairedBarChart = function () {
            var container = d3.select('div.workforce-data-center-hover')

            container.selectAll('svg').remove()

            var svg = container.append('svg')

            var data = stateHoverData,
                columns = []

            $.each(data[0], function (index, key) {
                columns.push(index)
            })

            data['columns'] = columns

            var keys = stateHoverChartColumns,
                numberOfKeys = keys.length,
                groupBy = stateHoverChartGroupBy,
                isSingleBar = true

            if (numberOfKeys > 1) {
                isSingleBar = false
            }

            var wrapTitle = d3
                .textwrap()
                .bounds({ height: 100, width: 372 })
                .method('tspans')

            var chartTitle = svg
                .append('text')
                .attr('class', 'dataset-heading')
                .attr('font-family', '"Avenir Next Pro", arial, sans-serif')
                .attr('font-size', '16px')
                .attr('fill', '#d48028')
                .attr('text-transform', 'uppercase')
                .text(stateHoverChartTitle)
                .call(wrapTitle)

            var titleHeight = chartTitle.node().getBoundingClientRect().height

            var margin = {
                top: 35 + titleHeight,
                right: 0,
                bottom: 32,
                left: 32
                // left: 0
            },
                width = 380 - margin.left - margin.right,
                height = 280 - margin.top - margin.bottom

            var g = svg
                .append('g')
                .attr(
                    'transform',
                    'translate(' + margin.left + ',' + margin.top + ')'
                )

            svg.attr('viewBox', '0 0 ' + 380 + ' ' + 280)

            var x0 = d3
                .scaleBand()
                .rangeRound([0, width])
                .paddingInner(0.1)

            var x1 = d3.scaleBand().padding(0.05)

            var y = d3.scaleLinear().rangeRound([height, 0])

            var z = d3
                .scaleOrdinal()
                .range([
                    '#1c9ad6',
                    '#dcab27',
                    '#00b0aa',
                    '#d48028',
                    '#5982af',
                    '#d16240',
                    '#5d6367'
                ])

            x0.domain(
                data.map(function (d) {
                    return d[groupBy]
                })
            )
            x1.domain(keys).rangeRound([0, x0.bandwidth()])

            y.domain([
                0,
                d3.max(data, function (d) {
                    return d3.max(keys, function (key) {
                        return deformatUnits(d[key])
                    })
                })
            ]).nice()

            chartTitle.attr('y', 15)

            g.append('text')
                .attr('class', 'state-heading')
                .attr('y', -margin.top + titleHeight + 16)
                .attr('x', -margin.left)
                .attr('font-family', '"Avenir Next Pro", arial, sans-serif')
                .attr('font-size', '13px')
                .attr('fill', '#727272')
                .attr('letter-spacing', '0.72px')
                .attr('text-transform', 'uppercase')
                .text(stateHoverCurrent)

            var barGroups = g
                .append('g')
                .selectAll('g')
                .data(data)
                .enter()
                .append('g')
                .attr('transform', function (d) {
                    return 'translate(' + x0(d[groupBy]) + ',0)'
                })

            // Bars
            barGroups
                .selectAll('rect')
                .data(function (d) {
                    return keys.map(function (key) {
                        return {
                            key: key,
                            value: d[key]
                        }
                    })
                })
                .enter()
                .append('rect')
                .attr('x', function (d) {
                    return x1(d.key)
                })
                .attr('y', function (d) {
                    return y(deformatUnits(d.value))
                })
                .attr('width', x1.bandwidth())
                .attr('height', function (d) {
                    return height - y(deformatUnits(d.value))
                })
                .attr('fill', function (d) {
                    if (isSingleBar) {
                        return z(d.value)
                    } else {
                        return z(d.key)
                    }
                })

            var wrap = d3
                .textwrap()
                .bounds({ height: 26, width: 80 })
                .method('tspans')

            var tickFormat = d3.axisLeft(y).ticks(8, 's')
            if (stateHoverChartValueFormat === 'usd') {
                tickFormat = d3.axisLeft(y).ticks(8, '$s')
            } else if (stateHoverChartValueFormat === 'percentage') {
                tickFormat = d3
                    .axisLeft(y)
                    .ticks(8)
                    .tickFormat(function (d) {
                        return d + '%'
                    })
            }

            g.append('g')
                .attr('class', 'y-axis')
                .call(tickFormat)

            g.append('g')
                .attr('class', 'axis')
                .attr('transform', 'translate(0,' + height + ')')
                .call(d3.axisBottom(x0))

            d3.selectAll('.axis text')
                .attr('y', '14.0')
                .attr('x', function () {
                    var number = -(x0.bandwidth() / 2 - 4)
                    number = number.toFixed(2)
                    number = number.toString()
                    return number
                })
                .call(wrap)

            container.selectAll('.legend').remove()

            if (!isSingleBar) {
                var legend = container
                    .append('div')
                    .attr('class', 'legend')
                    .selectAll('p')
                    .data(function () {
                        return keys.slice()
                    })

                var p = legend
                    .enter()
                    .append('p')
                    .attr('class', 'list-item')
                p.append('span')
                    .attr('class', 'key-dot')
                    .style('background', function (d, i) {
                        return z(d)
                    })
                p.insert('span')
                    .attr('class', 'text')
                    .text(function (d, i) {
                        return d
                    })
            }
        }

        var deformatUnits = function (unit) {
            // Make sure to make what appears to be a number
            // an actual integer or min and max won't work
            var deformattedUnit
            if (hasNumber(unit) && /\,/.test(unit)) {
                var unit = unit.replace(/\,/g, '')
            }
            if (hasNumber(unit) && /\$/.test(unit)) {
                deformattedUnit = +unit.replace(/\$/g, '')
            } else if (hasNumber(unit) && /\%/.test(unit)) {
                deformattedUnit = +unit.replace(/\%/g, '')
            } else if (hasNumber(unit)) {
                deformattedUnit = +unit
            } else {
                deformattedUnit = unit
            }
            return deformattedUnit
        }

        // Regex test for number
        var hasNumber = function (unit) {
            return /\d/.test(unit)
        }

        var renderStackedBarChart = function () {
            var container = d3.select('div.workforce-data-center-hover')

            container.selectAll('svg').remove()

            var svg = container.append('svg')

            var wrapTitle = d3
                .textwrap()
                .bounds({ height: 50, width: 372 })
                .method('tspans')

            var chartTitle = svg
                .append('text')
                .attr('class', 'dataset-heading')
                .text(stateHoverChartTitle)
                .call(wrapTitle)

            var titleHeight = chartTitle.node().getBoundingClientRect().height

            var margin = {
                top: 35 + titleHeight,
                right: 12,
                bottom: 20,
                left: 32
            },
                width = 380 - margin.left - margin.right,
                height = 280 - margin.top - margin.bottom

            var g = svg
                .append('g')
                .attr(
                    'transform',
                    'translate(' + margin.left + ',' + margin.top + ')'
                )

            svg.attr('viewBox', '0 0 ' + 380 + ' ' + 280)

            var x = d3
                .scaleBand()
                .rangeRound([0, width])
                .paddingInner(0.5)
                .align(0.1)

            var y = d3.scaleLinear().rangeRound([height, 0])

            var z = d3
                .scaleOrdinal()
                .range([
                    '#1c9ad6',
                    '#dcab27',
                    '#00b0aa',
                    '#d48028',
                    '#5982af',
                    '#d16240',
                    '#5d6367'
                ])

            var data = stateHoverData,
                columns = [],
                isReversed = false

            var keys = stateHoverChartColumns,
                numberOfKeys = keys.length,
                isSingleBar = true

            if (numberOfKeys > 1) {
                isSingleBar = false
            }

            var groupBy = stateHoverChartGroupBy,
                // keys = [],
                groupByKeys = []

            var totals = [0]

            // Build keys
            // Exclude group and Area (state)
            // $.each(data[0], function( dataIndex, dataValue ) {
            //     console.log(dataIndex,dataValue);
            //     if ( dataIndex == 'Area' || dataIndex == groupBy ) return;
            //     keys.push(dataIndex);
            // });

            // GroupBy Keys
            $.each(data, function (index, key, value) {
                groupByKeys.push(key[groupBy])
            })

            console.log('KEYS', keys)
            console.log('GROUPBY', groupBy)
            console.log('GROUPBYKEYS', groupByKeys)

            $.each(data, function (dataIndex, dataValue) {
                var total = 0
                $.each(keys, function (index, key, value) {
                    total = dataValue[key] + total
                })
                data[dataIndex].total = total
                totals.push(total)
            })

            // $.each(data[0], function( index, key ) {
            //     columns.push(index);
            // });
            //
            // data.columns = columns;

            if (isReversed) {
                x.domain(keys)
            } else {
                x.domain(
                    data.map(function (d) {
                        return d[groupBy]
                    })
                )
            }

            y.domain(d3.extent(totals)).nice()

            z.domain(keys)

            chartTitle.attr('y', 15)

            g.append('text')
                .attr('class', 'state-heading')
                .attr('y', -margin.top + 18 + 13)
                .attr('x', -margin.left)
                .text(stateHoverCurrent)

            var groups

            if (isReversed) {
                groups = d3
                    .nest()
                    .key(function (d) {
                        return d[groupBy]
                    })
                    .entries(data)
                var testStack = d3.stack().keys([groupBy])(data)
            } else {
                groups = d3.stack().keys(keys)(data)
            }

            var barGroups = g
                .append('g')
                .selectAll('g')
                .data(groups)
                .enter()
                .append('g')
                .attr('fill', function (d) {
                    if (isReversed) {
                        return z(d.key)
                    } else {
                        return z(d.key)
                    }
                })
                .selectAll('rect')
                .data(function (d) {
                    // console.log(d);
                    return d
                })
                .enter()
                .append('rect')
                .attr('x', function (d) {
                    console.log('x', d.data[groupBy])
                    return x(d.data[groupBy])
                })
                .attr('y', function (d) {
                    // console.log(d);
                    // return y( d[1] );
                    if (d[1] > 0) {
                        return y(d[1])
                    } else {
                        return y(d[0])
                    }
                })
                .attr('height', function (d) {
                    return Math.abs(y(d[0]) - y(d[1]))
                })
                .attr('width', x.bandwidth())

            var xAxisText = g
                .append('g')
                .attr('class', 'axis')
                .attr('transform', 'translate(0,' + height + ')')
                .call(d3.axisBottom(x))

            var tickFormat = d3.axisLeft(y).ticks(8, 's')
            if (stateHoverChartValueFormat === 'usd') {
                tickFormat = d3.axisLeft(y).ticks(8, '$s')
            } else if (stateHoverChartValueFormat === 'percentage') {
                tickFormat = d3
                    .axisLeft(y)
                    .ticks(8)
                    .tickFormat(function (d) {
                        return d + '%'
                    })
            }

            g.append('g')
                .attr('class', 'y-axis')
                .call(tickFormat)

            container.selectAll('.legend').remove()

            if (!isSingleBar) {
                var legend = container
                    .append('div')
                    .attr('class', 'legend')
                    .selectAll('p')
                    .data(function () {
                        if (isReversed) {
                            return groupByKeys.slice()
                        } else {
                            return keys.slice()
                        }
                    })

                var p = legend
                    .enter()
                    .append('p')
                    .attr('class', 'list-item')
                p.append('span')
                    .attr('class', 'key-dot')
                    .style('background', function (d, i) {
                        return z(d)
                    })
                p.insert('span')
                    .attr('class', 'text')
                    .text(function (d, i) {
                        return d
                    })
            }
        }

        var appendSeeMore = function () {
            if (stateFilterList.length > 0) {
                stateTableShowAll()
                return
            }
            $('section.state div.dataTables_wrapper').append(
                '<div class="dataTables-show-more"><button class="button button--blue">Show more</button></div>'
            )

            $('section.state div.dataTables-show-more button').click(function (
                event
            ) {
                stateTableShowAll()
            })
        }

        var stateTableShowAll = function () {
            var stateTableWrapper = $('section.state div.dataTables_wrapper')
            if (!stateTableWrapper.hasClass('show-all')) {
                $('section.state div.dataTables_wrapper').addClass('show-all')
            }
        }

        var dataTableScrollTest = function (table) {
            var tableWidth = table.outerWidth(),
                tableContainer = table.parent(),
                tableContainerWidth = tableContainer.outerWidth(true),
                scrollForMore = tableContainer.siblings(
                    'span.workforce-data-center-scroll-for-more'
                )

            if (tableWidth > tableContainerWidth) {
                scrollForMore.addClass('is-active')
            } else {
                scrollForMore.removeClass('is-active')
            }
        }

        var updateMethodology = function (target, copy) {
            var methodologyContainer = target.find(
                'div.workforce-data-center-methodology-container'
            ),
                methodologyCopy = methodologyContainer.find('div.copy')
            methodologyCopy.empty().html(copy)
            if (copy === '') {
                methodologyContainer.removeClass('is-active')
            } else {
                methodologyContainer.addClass('is-active')
            }
        }

        $('div.workforce-data-center-methodology-container div.heading').click(
            function () {
                var clicked = $(this),
                    copy = clicked.parent().find('div.copy')
                if (copy.hasClass('is-active')) {
                    copy.removeClass('is-active')
                    clicked.removeClass('is-active')
                } else {
                    copy.addClass('is-active')
                    clicked.addClass('is-active')
                }
            }
        )

        // Button gets created late
        // Wait until doc ready
        $(document).ready(function () {
            $(
                'body.page-template-workforce-data-center button.constructive-tab-button'
            ).click(function () {
                var clickedButton = $(this),
                    groupLabel = clickedButton.data('tab-label')

                if (clickedButton.hasClass('is-active')) {
                    updateURIParameterByName('tab', encodeSpacesToPlus(groupLabel))
                }
            })
        })

        $(window).resize(function () {
            dataTableScrollTest(stateTable)
            dataTableScrollTest(nationalTable)
        })

        $('body').on('constructive-tab-change', function () {
            dataTableScrollTest(stateTable)
            dataTableScrollTest(nationalTable)
        })

        stateTable.on('draw.dt', function () {
            dataTableScrollTest(stateTable)
        })

        nationalTable.on('draw.dt', function () {
            dataTableScrollTest(nationalTable)
        })

        // Spaces to plus signs
        function encodeSpacesToPlus(string) {
            if (string === null) return null
            return string.split(' ').join('+')
        }

        // Spaces to plus signs
        function decodePlusToSpace(string) {
            if (string === null) return null
            return string.split('+').join(' ')
        }

        // Get URI vars
        function getURIParameterByName(name, url) {
            if (!url) url = window.location.href
            name = name.replace(/[\[\]]/g, '\\$&')
            var regex = new RegExp('[#&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url)
            if (!results) return null
            if (!results[2]) return ''
            return results[2].replace(/\+/g, ' ')
        }
        // Update URI vars
        var updateURIParameterByName = function (name, value, url) {
            if (!url) url = window.location.href
            var re = new RegExp('([#&])' + name + '=.*?(&|$)', 'i'),
                separator = url.indexOf('#') !== -1 ? '&' : '#',
                updatedURL = ''
            if (value === null) value = ''
            if (url.match(re)) {
                if (value === '') {
                    updatedURL = url.replace(re, '$1' + '$2')
                } else {
                    updatedURL = url.replace(re, '$1' + name + '=' + value + '$2')
                }
            } else {
                if (value === '') {
                    updatedURL = url
                } else {
                    updatedURL = url + separator + name + '=' + value
                }
            }
            updatedURL = updatedURL.replace('&&', '&')
            history.replaceState(null, '', updatedURL)
        }

        $('body').on('mouseenter', 'td.sorting_1', function (e) {
            const td = $(e.target).closest('td.sorting_1')
            if (!td.find('> span.snapshot-chart-download').length) {
                // console.log(td)
                const downloadButton = $('<span>', {
                    class: 'snapshot-chart-download'
                }).html(
                    `<svg aria-hidden="true" data-prefix="far" data-icon="arrow-alt-circle-down" class="svg-inline--fa fa-arrow-alt-circle-down fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"></path></svg>`
                )
                td.append(downloadButton)
                setTimeout(function () {
                    $(downloadButton).addClass('showing')
                }, 1)
            }
        })

        $('body').on('mouseleave', 'td.sorting_1', function (e) {
            const span = $(e.target)
                .closest('td.sorting_1')
                .find('> span.snapshot-chart-download')
            if (span.length) {
                span.remove()
            }
        })

        $('body').on('click', '.snapshot-chart-download', function () {
            const element = document.querySelector(
                '.workforce-data-center-hover.is-active'
            )
            const filename = slugify(sanitize(stateHoverChartTitle)).toLowerCase()

            const styleString = element.style

            // saveAs(
            //     serialize(element),
            //     `${filename}.svg`
            // )

            element.style = ''
            domtoimage.toBlob(element).then(function (blob) {
                window.saveAs(blob, `${filename}.png`)
            })

            element.style = styleString
        })
    })(jQuery)
